import { Component, OnInit } from "@angular/core";
import { TypeaheadMatch, TypeaheadModule } from "ngx-bootstrap/typeahead";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Account, WatchedAccount, XeroIntegrationService } from "src/app/dashboard/xero-integration.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";



@Component({
    selector: "app-xero-accounts-modal",
    templateUrl: "./xero-accounts-modal.component.html",
    styleUrls: ["./xero-accounts-modal.component.scss"],
    imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    TypeaheadModule
]
})
export class XeroAccountsModalComponent implements OnInit {
  connectionUuid: string = "";

  availableAccounts: Account[] = [];
  selectedAccount = {} as Account;
  watchedAccounts: WatchedAccount[] = [];

  constructor(
    private xeroServices: XeroIntegrationService,
    public bsModalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.xeroServices.getAvailableAccounts(this.connectionUuid)
    .subscribe((res: any) => {
      this.availableAccounts = res.accounts;
    });
    this.getCompanyAccounts();
  }

  getCompanyAccounts() {
    this.xeroServices.getCompanyAccounts(this.connectionUuid)
    .subscribe((res: WatchedAccount[]) => {
      this.watchedAccounts = res.sort((a, b) => +a.external_object.Code-+b.external_object.Code);
    });
  }

  selectAccount(event: TypeaheadMatch) {
    this.selectedAccount = event.item;
  }

  addAccountToCompany() {
    this.xeroServices.addAccountToCompany(this.connectionUuid, this.selectedAccount).subscribe(
      (res: any) => {
        this.getCompanyAccounts();
        this.selectedAccount = {} as Account;
      },
      (err: any) => { }
    );
  }

  removeAccountFromCompany(removedAccountID: string) {
    this.xeroServices.removeAccountFromCompany(removedAccountID).subscribe(
      (res: any) => {
        this.watchedAccounts = this.watchedAccounts.filter(
          (wAccount: WatchedAccount) => wAccount.uuid !== removedAccountID
        );
      },
      (err: any) => { }
    );
  }
}
